import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setUserProfile } from '../../../redux/actions/authActions';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { _axiosCall } from '../../helpers/apicalls';
import { _formatNumber, _formatNumberDecimal } from '../../helpers/utils';
import { premiumCreditPacks } from './PremiumCreditsPurchaseModal';

var apiUrl = process.env.API_ROOT;

var PurpleSwitch = withStyles({
  switchBase: {
    '&$checked': { color: '#780F9E' },
    '&$checked + $track': { backgroundColor: '#780F9E' }
  },
  checked: {},
  track: {}
})(Switch);

class AutoRechargeSettings extends Component {
  constructor(props) {
    super(props);
    var autoRecharge = (props.user && props.user.autoRecharge) || {};
    this.state = {
      enabled: !!autoRecharge.enabled,
      pack_id: autoRecharge.pack_id || 'pack_2',
      threshold: autoRecharge.threshold || 10,
      saving: false
    };
  }

  // The pack is the user's choice — always seed and re-sync from their saved setting.
  //
  // This used to accept a `defaultPackId` prop (the caller's "right-sized" pack for the export)
  // and let it win over autoRecharge.pack_id. That made the selector impossible to change:
  // picking a pack saved it, the save pushed a new user object into Redux, and the resulting
  // componentDidUpdate re-applied defaultPackId over the choice that had just been saved.
  // Mounting also force-saved the right-sized pack over whatever the user had configured,
  // silently rewriting an account setting they never touched.
  componentDidMount() {
    var autoRecharge = (this.props.user && this.props.user.autoRecharge) || {};
    if (this.props.autoEnable && !autoRecharge.enabled) {
      this.setState({ enabled: true });
      this._saveSettings({ enabled: true });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user !== this.props.user && this.props.user && this.props.user.autoRecharge) {
      var ar = this.props.user.autoRecharge;
      this.setState({
        enabled: !!ar.enabled,
        pack_id: ar.pack_id || 'pack_2',
        threshold: ar.threshold || 10
      });
    }
  }

  _saveSettings = (overrides) => {
    var _this = this;
    var { user } = this.props;
    var state = Object.assign({}, this.state, overrides || {});

    this.setState({ saving: true });

    _axiosCall({
      url: apiUrl + '/buyerslist/user/auto-recharge-settings',
      method: 'post',
      query: {
        user: { id: user.id || user.sub, email: user.email },
        autoRecharge: {
          enabled: state.enabled,
          pack_id: state.pack_id,
          threshold: parseInt(state.threshold, 10) || 10
        }
      }
    })
      .then(function (res) {
        _this.setState({ saving: false });
        if (res && res.success && _this.props.setUserProfile) {
          _this.props.setUserProfile(Object.assign({}, user, {
            autoRecharge: {
              enabled: state.enabled,
              pack_id: state.pack_id,
              threshold: parseInt(state.threshold, 10) || 10
            }
          }));
        }
        if (_this.props.onSave) _this.props.onSave(state);
      })
      .catch(function (err) {
        console.error('Failed to save auto-recharge settings', err);
        _this.setState({ saving: false });
      });
  };

  _handleToggle = (e) => {
    var enabled = e.target.checked;
    this.setState({ enabled: enabled, userToggled: true }, function () {
      this._saveSettings({ enabled: enabled });
    }.bind(this));
  };

  _handlePackChange = (e) => {
    var pack_id = e.target.value;
    this.setState({ pack_id: pack_id }, function () {
      this._saveSettings({ pack_id: pack_id });
    }.bind(this));
  };

  _handleThresholdBlur = () => {
    this._saveSettings();
  };

  render() {
    var { enabled, pack_id, threshold, saving } = this.state;

    return (
      <div className="auto-recharge-settings">
        {this.props.autoEnable && !enabled && this.state.userToggled && (
          <div style={{ marginBottom: 10, padding: '10px 14px', background: '#FFF5F5', borderRadius: 8, border: '1px solid #FED7D7', fontSize: 13, color: '#d32f2f' }}>
            You have no premium credits. Auto-recharge must be enabled to continue.
          </div>
        )}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <FormControlLabel
            style={{ alignItems: 'flex-start' }}
            control={
              <PurpleSwitch
                checked={enabled}
                onChange={this._handleToggle}
                size="small"
              />
            }
            label={<span style={{ fontSize: 14, color: '#111827', fontWeight: 600 }}>Auto-recharge when premium credits run low<span style={{ display: 'block', fontSize: 11, color: '#9ca3af', lineHeight: '1.3', fontWeight: 400, marginTop: 2 }}>Keeps your export running by purchasing more credits as needed. If off, the export stops when credits run out and you'll receive partial results.</span></span>}
          />
          {saving && <span style={{ fontSize: 12, color: '#9600BF' }}>Saving...</span>}
        </div>

        {enabled && (
          <div style={{ marginTop: 10, display: 'flex', gap: 12, alignItems: 'flex-end', flexWrap: 'wrap' }}>
            <div style={{ flex: '1 1 240px' }}>
              <label style={{ fontSize: 12, color: '#6b7280', display: 'block', marginBottom: 4 }}>Credit pack</label>
              <Select
                value={pack_id}
                onChange={this._handlePackChange}
                variant="outlined"
                style={{ width: '100%', fontSize: 13, height: 40 }}
                renderValue={function (val) {
                  var p = premiumCreditPacks.find(function (pk) { return pk.id === val; });
                  if (!p) return val;
                  var PackIcon = p.icon;
                  var totalCost = (p.credits * p.pricePerCredit).toFixed(2);
                  return (
                    <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                      <PackIcon size={16} style={{ color: '#780F9E' }} />
                      {p.label} — {_formatNumber(p.credits)} credits @ ${_formatNumberDecimal(p.pricePerCredit)}/credit (${totalCost})
                    </span>
                  );
                }}
              >
                {premiumCreditPacks.map(function (pack) {
                  var totalCost = (pack.credits * pack.pricePerCredit).toFixed(2);
                  var PackIcon = pack.icon;
                  return (
                    <MenuItem key={pack.id} value={pack.id} style={{ fontSize: 13 }}>
                      <ListItemIcon style={{ minWidth: 28 }}>
                        <PackIcon size={16} style={{ color: '#780F9E' }} />
                      </ListItemIcon>
                      {pack.label} — {_formatNumber(pack.credits)} credits @ ${_formatNumberDecimal(pack.pricePerCredit)}/credit (${totalCost})
                    </MenuItem>
                  );
                })}
              </Select>
            </div>

            <div style={{ flex: '0 0 160px' }}>
              <label style={{ fontSize: 12, color: '#6b7280', display: 'block', marginBottom: 4 }}>Recharge below</label>
              <TextField
                type="number"
                value={threshold}
                onChange={function (e) { this.setState({ threshold: e.target.value }); }.bind(this)}
                onBlur={this._handleThresholdBlur}
                inputProps={{ min: 1, max: 500, style: { height: 40, padding: '0 10px', boxSizing: 'border-box', fontSize: 13 } }}
                size="small"
                variant="outlined"
                style={{ width: '100%' }}
                InputProps={{
                  style: { height: 40, fontSize: 13 },
                  endAdornment: <span style={{ fontSize: 12, color: '#6b7280', whiteSpace: 'nowrap' }}>credits</span>
                }}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user || {}
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ setUserProfile: setUserProfile }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AutoRechargeSettings);
